export const markMatch = (text: string, term: string, element: string = 'mark'): string => {
  const index = text.toUpperCase().indexOf(term.toUpperCase());
  if (index < 0) {
    return text;
  }
  return `${text.substring(0, index)}<${element}>${text.substring(index, index + term.length)}</${element}>${text.substring(index + term.length)}`;
};
